window.stimulusApp.register(
  "activity",
  class extends Stimulus.Controller {
    static values = { track: Object }

    connect() {
      if (this.hasTrackValue) {
        this.track({ params: { track: this.trackValue } })
      }
    }

    track({
      params: {
        track: { category, action, label, value },
      },
    }) {
      Activity.track(category, action, label, value)
    }

    capture({ params: { event, properties = {} } }) {
      Activity.capture(event, properties)
    }
  },
)
